import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { TrainDataService } from '../../../trains/services/train-data.service';
import { TripDataService } from '../../../trips/services/trip-data.service';
import { StateService } from '@uirouter/core';
import { Train } from '../../../trains/models/train';
import {ConfigurationDataService} from '../../../configurations/services/configuration-data.service';
import { ToastBehaviorSubjectService } from '../../../../shared/services/toast-behavior-subject.service';
import { MessageService } from 'primeng/api';
import {AnalysisInformationService} from '../../services/analysis-information.service';
import {DataImportExportService} from '../../../../shared/services/data-import-export.service';

const nocUtil = require('../../../../../../noc/util/noc-util');
const messageDiscriptors = require('../../../../../../noc/util/messageDiscriptors');
@Component({
  selector: 'app-analysis-information',
  template: require('./analysis-information.component.html'),
  styles: [require('./analysis-information.component.sass')]
})
export class AnalysisInformationComponent implements OnInit {
  isTrip: boolean;
  selectedTrips: any[] = [];
  trainData: any;
  trains: Train[] | undefined;
  train: Train | undefined;

  previousTrip: any;
  nextTrip: any;

  urlParameters = JSON.parse(JSON.stringify(this.$state.params));
  selectedOfficialId: any;

  selectedTripId: number;

  periodTzFrom: any;
  periodTzTo: any;

  maxFromDateTime: any;
  minToDateTime: any;
  maxToDateTime = new Date()

  updatePeriod: boolean = true;

  isMaxPeriod: boolean;

  activeConfig: any;
  errorMessage: any;

  selectedCsvMessage: any;
  csvExports: any[] = messageDiscriptors.getCsvExports();

  loading = false;

  trainTypeObjects: any[];
  maintainersObjects: any[];

  selectedMaintainer: string | undefined;
  selectedTrainType: string | undefined;


  @Output() reloadPeriod = new EventEmitter<any>();

  @Output() changeTrip = new EventEmitter<any>();


  constructor(
    public $state: StateService,
    @Inject('ProjectService') private projectService: any,
    @Inject('AuthenticationFactory') private authenticationFactory: any,
    @Inject('TimeZoneFactory') private timeZoneFactory: any,
    @Inject('TripOverviewFactory') private tripOverviewFactory: any,
    @Inject('SqiFactory') private sqiFactory: any,
    @Inject("TrainTypeService") private trainTypeService: any,
    @Inject("TrainMaintainerService") private trainMaintainerService: any,
    private trainDataService: TrainDataService,
    private tripDataService: TripDataService,
    private configurationDataService: ConfigurationDataService,
    private toastBehaviorSubjectService: ToastBehaviorSubjectService,
    private messageService: MessageService,
    private analysisInformationService: AnalysisInformationService,
    private dataImportExportService: DataImportExportService
  ) {

    this.toastBehaviorSubjectService.changeOccured.subscribe((message) => {
      this.messageService.add(message);
    })
  }

  async ngOnInit()  {

    let data;
    const utcStart = this.$state.params ? this.timeZoneFactory.formatWithTimeZone(this.$state.params.startDate) : null;
    const utcEnd = this.$state.params ? this.timeZoneFactory.formatWithTimeZone(this.$state.params.endDate) : null;
    this.activeConfig = await this.configurationDataService.getProjectConfigurations(this.$state.params.projectId).toPromise();

    if (this.$state.current && this.$state.current.name) {
        if (this.$state.current.name.includes('period-analysis')) {
            this.updatePeriod = false;
            this.isTrip = false;
            try {
              data = await this.trainDataService.getPeriodData(utcStart, utcEnd, this.$state.params.projectId, this.$state.params.trainId);
            } catch (error) {
              this.$state.go('period.search', {
                projectId: this.$state.params.projectId
              })
            }
        }
        if (this.$state.current.name.includes('trip-analysis')) {
          this.updatePeriod = false;
            this.isTrip = true;
            try {
              data = await this.tripDataService.getTripById(this.$state.params.tripId, this.$state.params.projectId);
            } catch (error) {
              this.$state.go('trip.search', {
                projectId: this.$state.params.projectId
              })
            }
        }
        await this.processData(data);

        this.loading = false;
    }
  }

  processData = async (data: any) => {
      if (data) {
        this.trainData = {
          relativeTrainId: data.trainId,
          from: data.departure,
          to: data.arrival,
          projectId: data.projectId,
          projectName: data.projectName,
          isTrip: this.isTrip,
          tripId: data.id,
          trajectory: data.trajectory,
          statistics: data.statistics,
          officialId: data.officialId
      };
      } else {
        this.trainData = {
          projectId: this.$state.params.projectId,
          isTrip: false,
          from: new Date(),
          to: new Date()
        }
        this.trainData.from.setHours(0,0, 0);
      }

      // make sure we got real dates in From and to.
      this.trainData.tzFrom = nocUtil.toDate(this.trainData.from);
      this.trainData.tzTo = nocUtil.toDate(this.trainData.to);

      const offset = this.timeZoneFactory.getOffset();

      if (0 < offset) {
          this.trainData.tzFrom = new Date(this.trainData.tzFrom.getTime() - offset);
          this.trainData.tzTo = new Date(this.trainData.tzTo.getTime() - offset);
      } else {
          this.trainData.tzFrom = new Date(this.trainData.tzFrom.getTime() + offset);
          this.trainData.tzTo = new Date(this.trainData.tzTo.getTime() + offset);
      }

      this.periodTzFrom = this.trainData.tzFrom;
      this.periodTzTo = this.trainData.tzTo;

      if (!this.trainData.isTrip) {
          const trains = await this.trainDataService.getTrainslist(this.trainData.projectId).toPromise();
          if (trains) {
            this.train = trains.find(train => train.relativeId === this.trainData.relativeTrainId);
            this.selectedOfficialId = this.train && this.train.officialId;
            this.trains = trains.sort((t1: Train, t2: Train) => t1.name > t2.name ? 1 : -1 );
            this.trainTypeObjects = this.trainTypeService.getTrainTypeObjects(this.trains);
            this.maintainersObjects = this.trainMaintainerService.getTrainMaintainerObjects(this.trains);
            const selectedTrain = this.trains.find(train => train.relativeId === this.trainData.relativeTrainId);
            this.selectedMaintainer = selectedTrain && selectedTrain.maintainer;
            this.selectedTrainType = selectedTrain && selectedTrain.trainType;
          }
          

      } else {
          this.previousTrip = this.tripOverviewFactory.getPreviousId(this.trainData.tripId);
          this.nextTrip = this.tripOverviewFactory.getNextId(this.trainData.tripId);
      }
      const tmpMap = this.tripOverviewFactory.getInformationMap();

      this.selectedTrips = [];
      tmpMap.forEach((value, key) => {
          this.selectedTrips.push({
              value,
              key
          });
      });

      const statistics = await this.sqiFactory.createProjectSpecficSqis(
          this.trainData.statistics,
          -999,
          this.projectService.getSelectedProjectId()
          );

      this.trainData.specificStatistics = statistics.filter(stat => !!stat).length > 0 ? statistics : null;
  }

  onReloadPeriod = (selectedOfficialId) => {
      const selectedTrain = this.trains && this.trains.find(train => train.officialId === selectedOfficialId);
      if (selectedTrain) {
        this.reloadPeriod.emit( {
          ...this.urlParameters,
          trainId: selectedTrain.relativeId, // add the new trainId to the parameters object
          startDate: this.periodTzFrom,
          endDate: this.periodTzTo
        });
      }

      this.loading = true;
  }

  onPeriodStartDateChange = (newDate) => {
    this.periodTzFrom = newDate;
    this.trainData.tzFrom = newDate;
    this.computeMaxRange();
    //this.checkIfPeriodUpdate();
  }

  onPeriodEndDateChange = (newDate) => {
    this.periodTzTo = newDate;
    this.trainData.tzTo = newDate;
    this.computeMaxRange();
    //this.checkIfPeriodUpdate();
  }

  checkIfPeriodUpdate = () => {
    if (this.trainData && this.trainData.tzFrom && this.trainData.tzTo) {
      this.updatePeriod = (this.trainData.tzFrom.replace(" ", "-") !== this.urlParameters.startDate) || (this.trainData.tzTo.replace(" ", "-") !== this.urlParameters.endDate)
    }
  }

  computeMaxRange = () => {
      this.isMaxPeriod = false;
      const projectConfiguration = this.activeConfig && this.activeConfig[0];

      if (projectConfiguration && projectConfiguration.periodRange && projectConfiguration.periodRange.periodOverviewRange) {
          const diff = new Date(Date.parse(this.trainData.tzTo)).getTime() - new Date(Date.parse(this.trainData.tzFrom)).getTime();
          const diffInDays = Math.round(diff / (1000 * 3600 * 24));
          if (diffInDays > projectConfiguration.periodRange.periodOverviewRange) {
              this.isMaxPeriod = true;
              this.errorMessage = 'Period Range must not exceed ' + projectConfiguration.periodRange.periodOverviewRange + ' days';
          }
      }
  }

  onChangeTrip = (selectedTripId) => {
    this.changeTrip.emit({
      ...this.urlParameters,
      tripId: selectedTripId
    });

  }

  getSlaMetadataByTitle = (title) => {
      return this.sqiFactory.getSlaByProperty('title', title, this.projectService.getSelectedProjectId());
  }

  createExportUrl = async () => {
    if (this.selectedCsvMessage) {
        const period = this.timeZoneFactory.formatUtcToBackendPeriod(this.trainData.from, this.trainData.to);
        const object = {
            trainId: this.trainData.relativeTrainId,
            projectId: this.trainData.projectId,
            from: period.start,
            to: period.end,
            token: this.authenticationFactory.getUser() && this.authenticationFactory.getUser().token
        };
        const url = nocUtil.createCsvUrlPeriod(this.selectedCsvMessage, object);
        const data = await this.analysisInformationService.getCSVMessages(url.replace(/[+]/g, '%2B')).toPromise();
        let exportName = "" + this.selectedOfficialId + "-" + this.selectedCsvMessage;

        this.dataImportExportService.exportCSV(data.messages, this.createExportColumns(data.fieldNames), exportName, data.separator);
    }
    }

    public createExportColumns(map: any) {
        let columns: [string, string][] = [];
        columns = Object.entries(map);
        return columns;
    }
}
